import React from "react";
import { StyleSheet, View } from "react-native";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { localizationStrings } from "./constants";

export interface IError {
  code?: string;
  message?: string;
}

export type ErrorDialogProps = {
  error: IError;
  visible: boolean;
  onClose: () => void;
};

export const ErrorDialog: React.FC<ErrorDialogProps> = ({
  error,
  visible,
  onClose,
}) => {
  const getErrorMessage = () => {
    if (
      error?.code &&
      localizationStrings.getString(`errorAmplifyAuth${error?.code || ""}`)
    ) {
      return localizationStrings.getString(
        `errorAmplifyAuth${error?.code || ""}`
      );
    } else if (error?.message) {
      return error?.message;
    }
    return "Unknown error";
  };

  return (
    <View style={styles.container}>
      <Dialog
        open={visible}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {localizationStrings.errorTile}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {getErrorMessage()}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} autoFocus>
            {localizationStrings.btnOk}
          </Button>
        </DialogActions>
      </Dialog>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {},
});
